module.exports = __webpack_public_path__ + "img/support_a2.2ddabd65.png";